import { padding, styled } from "@mui/system";
import BreakPoints from "src/general/constants/breakPoints";
import Colors from "src/general/constants/colors";

export const NavMenuModule = styled("div")(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	flexWrap: "wrap",
	gap: theme.spacing(2),
	padding: theme.spacing(3),
	flexShrink: 0,
	maxWidth: "287px",
	boxSizing: "border-box",
	backgroundColor: theme.palette.common.white,
	height: "max-content",
	boxShadow: "0px 4px 16px 0px #7474741F",
	borderRadius: "24px",
	position: "sticky",
	top: "1px",
	[`@media (max-width: ${BreakPoints.FHD_1919}px)`]: {
		gap: theme.spacing(1),
	},
	[`@media  (min-width: ${BreakPoints.TABLET_1023}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			width: "118px",
			gap: "8px",
			padding: "8px",
		},
	[`@media (max-width: ${BreakPoints.TABLET_1023}px)`]: {
		display: "none",
	},
}));

export const LineStrix = styled("div")(() => ({
	position: "relative",
	"&::after": {
		content: '""',
		position: "absolute",
		left: 0,
		bottom: 0,
		width: "100%",
		height: "1px",
		background:
			"repeating-linear-gradient(to right, transparent, " +
			Colors.DARK_GREY3 +
			" 3px, transparent 10px, transparent 20px)",
	},
}));
